const moduleRoutes = [
  {
    path: "/setting",
    name: "settings",
    children: [
      {
        path: "",
        name: "settingList",
        component: () => import("@/modules/setting/list/List.vue"),
        meta: {
          resource: "settings",
          action: "view",
          layout: "default",
          auth: true,
          title: "Settings",
          breadcrumbs: [{ title: "Setting List", routeName: "settingList" }]
        }
      },
      {
        path: "new",
        name: "settingNew",
        component: () => import("@/modules/setting/entry/New.vue"),
        meta: {
          resource: "settings",
          action: "create",
          layout: "default",
          auth: true,
          title: "Create Setting",
          breadcrumbs: [
            { title: "Setting List", routeName: "settingList" },
            { title: "New", routeName: "settingNew" }
          ]
        }
      },
      {
        path: ":id/edit",
        name: "settingEdit",
        component: () => import("@/modules/setting/entry/Edit.vue"),
        meta: {
          resource: "settings",
          action: "edit",
          layout: "default",
          auth: true,
          title: "Edit Setting",
          breadcrumbs: [
            { title: "Setting List", routeName: "settingList" },
            { title: "Edit", routeName: "settingEdit" }
          ]
        }
      }
    ]
  }
]

export default moduleRoutes
